// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mgI0","left":"styles_left__1L3Vc"};